// extracted by mini-css-extract-plugin
export default {"pwInputBox":"passwordChange_pwInputBox__+4OEC"};